<template>
    <div :class="getCSSClass('copy-calendarevent-component-container')">
        <div :class="getCSSClass('repository-manager-function-popup-header') + ' ' + getCSSClass('repository-manager-function-popup-blue-header')">
            <h2 :class="getCSSClass('repository-manager-function-popup-header-mainheader')">
                <span v-html="icon('copy')+' '+title"></span>
                <button :class="getCSSClass('edit-form-form-close-button')"
                        v-on:click="emitAndResetComponent('editing-canceled')"
                        type="button"
                        v-html="icon('close')"
                        style="margin-left: auto"
                ></button>

            </h2>
        </div>

        <template v-if="mode == 'start'">
            <div :class="getCSSClass('repository-manager-function-popup-row')">
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <label v-html="chooseLabel"></label></div>
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <div v-if="loading" v-html="loadingIndicator"></div>
                    <template v-else>
                        <select style="width: 100%" v-model="selectedElementId">
                            <option v-for="element in elements"
                                    v-html="element.short_select_label"
                                    :value="element.id"></option>
                        </select>
                    </template>
                </div>
            </div>
            <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                <button :class="getCSSClass('repository-manager-popup-save-button')"
                        v-on:click="initCopy"
                        :disabled="selectedElementId == -1"
                ><span v-html="icon('copy')" class="mr-2"></span><span v-html="translate('Folytatás')"></span>
                </button>
                <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                        v-on:click="emitAndResetComponent('editing-canceled')"
                ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                </button>
            </div>

        </template>
        <template v-if="mode == 'edit'">
            <edit-form
                    v-bind:data-url="actualUrls.dataUrl"
                    v-bind:save-url="actualUrls.saveUrl"
                    v-bind:ajax-operations-url="actualUrls.ajaxOperationsUrl"
                    v-on:submit-success="emitAndResetComponent('submit-success')"
                    v-on:editing-canceled="emitAndResetComponent('editing-canceled')"
                    redirect-to-response-on-success="false"
                    :buttons="buttons"
                    :show-header="false"
            ></edit-form>

        </template>
    </div>
</template>

<script>
    import {editformReplacementMixin} from "./mixins/editformReplacementMixin";

    export default {
        mixins: [editformReplacementMixin],
        props: {
            title: {type: String},
            chooseLabel: {type: String},
        },
        data: function () {
            return {
                mode: 'start',
                loading: true,
                elements: [],
                selectedElementId: -1,
            }
        },
        mounted() {
            this.fetchElements();
        },
        methods: {
            fetchElements: function() {
                window.axios.post(this.ajaxOperationsUrl, {action: 'fetchElements'})
                    .then((response) => {
                        this.elements = response.data.elements;
                        this.loading = false;
                    })
            },
            initCopy: function() {
                this.mode = 'edit';
            },
            addSelectedElementToUrl: function(url) {
                let result = new URL(url);
                result.searchParams.set('selectedElement', this.selectedElementId);
                return result.toString();
            }
        },
        computed: {
            actualUrls: function() {
                return {
                    dataUrl: this.addSelectedElementToUrl(this.dataUrl),
                    saveUrl: this.addSelectedElementToUrl(this.saveUrl),
                    ajaxOperationsUrl: this.addSelectedElementToUrl(this.ajaxOperationsUrl),
                }
            }
        },
        watch: {}

    }
</script>
